import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material'
import GetAppIcon from '@material-ui/icons/GetApp'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useEffect, useState } from 'react'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons'
import LastPageIcon from '@mui/icons-material/LastPage'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import { useDispatch } from 'react-redux'
import { CSVLink } from 'react-csv'
import { getRequest } from '../../globalhelper/helper'
import { hideLoader, showLoader } from '../../redux/Common/commonActions'
import moment from 'moment'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

function AI_Mapping () {
  let [formData, setFormdata] = useState({})
  let [dropDown, setDropDown] = useState(null)
  let [Companies, setCompanies] = useState(null)
  let [vendorDetails, setVendorDetails] = useState([])
  let [TableData, setTableData] = useState([])
  let [filtered, setFiltered] = useState([])
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  let dispatch = useDispatch()

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - TableData.length) : 0

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  useEffect(() => {
    getRequest(`api/upload/getCompanyAndVendors`)
      .then(response => {
        console.log(response.res.data)
        const responseData = JSON.parse(response.res.data)
        const orgname = [...new Set(responseData.map(item => item.orgname))]
        setCompanies(
          responseData
            .map(data => ({
              orgname: data.orgname,
              orgid: data.orgid
            }))
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  obj =>
                    obj.orgid === value.orgid && obj.orgname === value.orgname
                )
            ) || []
        )
        setVendorDetails(
          responseData
            .map(data => ({
              vendorid: data.vendorid,
              vendorname: data.vendorname
            }))
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  obj =>
                    obj.vendorid == value.vendorid &&
                    obj.vendorname === value.vendorname
                )
            ) || []
        )

        setVendorDetails(
          responseData
            .map(data => ({
              vendorid: data.vendorid,
              vendorname: data.vendorname
            }))
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  obj =>
                    obj.vendorid == value.vendorid &&
                    obj.vendorname === value.vendorname
                )
            )
        )

        if (orgname.length === 1) {
          setFormdata(prev => {
            return { ...prev, company: orgname[0] }
          })
        }
      })
      .catch(err => console.log(err))
  }, [])

  const handleSubmit = async () => {
    try {
      dispatch(showLoader())
      let { res } = await getRequest(
        `api/vr2/getAI_MapData?orgid=${formData.Company.orgid}`
      )
      setTableData(JSON.parse(res.data))
      setFiltered(JSON.parse(res.data))
      let TargetCampaign = new Set([
        ...JSON.parse(res?.data)?.map(data => data?.['Target Campaign Name'])
      ])
      let TargetPlatform = new Set([
        ...JSON.parse(res?.data)?.map(data => data?.['Target Platform'])
      ])
      let SourceCampaign = new Set([
        ...JSON.parse(res?.data)?.map(data => data?.['Source Campaign Name'])
      ])
      let SourcePlatform = new Set([
        ...JSON.parse(res?.data)?.map(data => data?.['Source Platform'])
      ])
      let ThemeName = new Set([
        ...JSON.parse(res?.data)?.map(data => data?.['ThemeName'])
      ])
      setDropDown(prev => ({
        ...prev,
        'Target Campaign Name': [...TargetCampaign],
        'Target Platform': [...TargetPlatform],
        ThemeName: [...ThemeName],
        'Source Platform': [...SourcePlatform],
        'Source Campaign Name': [...SourceCampaign]
      }))
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleTableChanges = (name, value, id) => {
    setTableData(prev =>
      prev.map(
        data => (data['Sno'] === id && { ...data, [name]: value }) || data
      )
    )
    setFiltered(prev =>
      prev.map(
        data => (data['Sno'] === id && { ...data, [name]: value }) || data
      )
    )

    console.log(
      TableData.map(
        data => (data['Sno'] === id && { ...data, [name]: value }) || data
      ),
      filtered.map(
        data => (data['Sno'] === id && { ...data, [name]: value }) || data
      )
    )
  }

  useEffect(() => {
    let filteredData = TableData.filter(
      data =>
        (data?.['Source Campaign Name'] ===
          formData?.['Source Campaign Name'] ||
          formData?.['Source Campaign Name'] === '' ||
          formData?.['Source Campaign Name'] === null ||
          formData?.['Source Campaign Name'] === undefined) &&
        (data?.['Source Platform'] === formData?.['Source Platform'] ||
          formData?.['Source Platform'] === '' ||
          formData?.['Source Platform'] === null ||
          formData?.['Source Platform'] === undefined) &&
        (data?.['ThemeName'] === formData?.['ThemeName'] ||
          formData?.['ThemeName'] === '' ||
          formData?.['ThemeName'] === null ||
          formData?.['ThemeName'] === undefined)
    )
    setFiltered(filteredData)
    console.log(
      TableData.filter(
        data =>
          (data?.['Source Campaign Name'] ===
            formData?.['Source Campaign Name'] ||
            formData?.['Source Campaign Name'] === '' ||
            formData?.['Source Campaign Name'] === null ||
            formData?.['Source Campaign Name'] === undefined) &&
          (data?.['Source Platform'] === formData?.['Source Platform'] ||
            formData?.['Source Platform'] === '' ||
            formData?.['Source Platform'] === null ||
            formData?.['Source Platform'] === undefined) &&
          (data?.['ThemeName'] === formData?.['ThemeName'] ||
            formData?.['ThemeName'] === '' ||
            formData?.['ThemeName'] === null ||
            formData?.['ThemeName'] === undefined)
      ),
      formData?.['Source Platform'],
      formData?.['Source Campaign Name'],
      formData?.['ThemeName']
    )
  }, [
    formData?.['ThemeName'],
    formData?.['Source Campaign Name'],
    formData?.['Source Platform']
  ])

  useEffect(() => {
    let SourceCampaign = [
      ...new Set(
        TableData?.map(
          data =>
            (formData?.['ThemeName'] &&
              formData?.['ThemeName'] === data?.['ThemeName'] &&
              data?.['Source Campaign Name']) ||
            (!formData?.['ThemeName'] && data?.['Source Campaign Name'])
        )
      )
    ].filter(data => data)
    let SourcePlatform = [
      ...new Set(
        TableData?.map(
          data =>
            (formData?.['Source Campaign Name'] &&
              formData?.['Source Campaign Name'] ===
                data?.['Source Campaign Name'] &&
              data?.['Source Platform']) ||
            (!formData?.['Source Campaign Name'] && data?.['Source Platform'])
        )
      )
    ].filter(data => data)
    let ThemeName = [
      ...new Set(TableData?.map(data => data?.['ThemeName']))
    ].filter(data => data)
    setDropDown(prev => ({
      ...prev,
      ThemeName: [...ThemeName],
      'Source Platform': [...SourcePlatform],
      'Source Campaign Name': [...SourceCampaign]
    }))
  }, [filtered])

  const handleChanges = (name, value) => {
    if (name === 'month' && value !== '') {
      var currentDate = moment(value)
      var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
      var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
      setFormdata(prev => {
        return { ...prev, fromDate: firstDay, toDate: lastDay }
      })
    }
    setFormdata({ ...formData, [name]: value })
  }
  function TablePaginationActions (props) {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props
    const [previousCount, setPreviousCount] = useState(count)

    useEffect(() => {
      if (count !== previousCount && page !== 0) {
        onPageChange(null, 0)
      }
      setPreviousCount(count)
    }, [count, page, onPageChange, previousCount])

    const handleFirstPageButtonClick = event => {
      onPageChange(event, 0)
    }

    const handleBackButtonClick = event => {
      onPageChange(event, page - 1)
    }

    const handleNextButtonClick = event => {
      onPageChange(event, page + 1)
    }

    const handleLastPageButtonClick = event => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label='first page'
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label='previous page'
        >
          {theme.direction === 'rtl' ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label='next page'
        >
          {theme.direction === 'rtl' ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label='last page'
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired
  }

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
        >
          <Typography variant='h6'>Search</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2}>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                size='small'
                fullWidth
                value={formData?.Company || null}
                options={Companies || []}
                getOptionLabel={option => option?.orgname || ''}
                isOptionEqualToValue={(option, value) =>
                  option?.orgid === value?.orgid
                }
                onChange={(event, newValue) =>
                  handleChanges('Company', newValue)
                }
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Company'
                    variant='outlined'
                    name='Company'
                  />
                )}
              />
            </Grid>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                options={vendorDetails || []}
                value={
                  formData.vendorid
                    ? vendorDetails.find(v => v.vendorid === formData.vendorid)
                    : null
                }
                onChange={(e, newValue) =>
                  handleChanges('vendorid', newValue ? newValue.vendorid : '')
                }
                fullWidth
                getOptionLabel={option => option?.vendorname || ''}
                isOptionEqualToValue={(option, value) =>
                  option.vendorid === value.vendorid
                }
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Vendor Name'
                    variant='outlined'
                    size='small'
                  />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='Period'
                  value={formData?.month}
                  views={['month', 'year']}
                  onChange={newValue => {
                    handleChanges('month', newValue.format('MM-YYYY'))
                  }}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={3}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleSubmit}
              >
                Submit
              </Button>
              &nbsp;&nbsp;
              <Button
                variant='contained'
                color='error'
                onClick={() => {
                  setFormdata({})
                  setTableData([])
                }}
              >
                Reset
              </Button>
              &nbsp;&nbsp;
              {TableData.length > 0 && (
                <Button variant='contained' color='success'>
                  <CSVLink
                    filename='Reports.csv'
                    data={TableData}
                    style={{ color: 'white' }}
                  >
                    <GetAppIcon fontSize='small' />
                  </CSVLink>
                </Button>
              )}
            </Grid>
          </Grid>
          {TableData.length > 0 && (
            <>
              <Typography variant='h6' pb={2}>
                Filter
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    size='small'
                    fullWidth
                    value={formData?.ThemeName || null}
                    options={dropDown?.ThemeName || []}
                    onChange={(event, newValue) =>
                      handleChanges('ThemeName', newValue)
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        label='ThemeName'
                        variant='outlined'
                        name='ThemeName'
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    size='small'
                    fullWidth
                    value={formData?.['Source Campaign Name'] || null}
                    options={dropDown?.['Source Campaign Name'] || []}
                    onChange={(event, newValue) =>
                      handleChanges('Source Campaign Name', newValue)
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        label='Source Campaign Name'
                        variant='outlined'
                        name='Source Campaign Name'
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    size='small'
                    fullWidth
                    value={formData?.['Source Platform'] || ''}
                    options={dropDown?.['Source Platform'] || []}
                    onChange={(event, newValue) =>
                      handleChanges('Source Platform', newValue)
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        label='Source Platform'
                        variant='outlined'
                        name='Source Platform'
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </AccordionDetails>
      </Accordion>
      {TableData.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {Object.keys(TableData[0]).map((key, index) => (
                  <TableCell
                    sx={
                      (key !== 'Sno' && {
                        whiteSpace: 'balance',
                        minWidth: '200px',
                        maxWidth: '200px',
                        p: 1
                      }) || { p: 1 }
                    }
                    key={index}
                  >
                    {key}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(filtered.length > 0 &&
                (rowsPerPage > 0
                  ? filtered.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : filtered
                ).map((key, index) => (
                  <TableRow key={index}>
                    {Object.keys(filtered[0]).map((value, i) => (
                      <TableCell
                        sx={
                          (value !== 'Sno' && {
                            whiteSpace: 'balance',
                            minWidth: '200px',
                            maxWidth: '200px',
                            p: 1
                          }) || { p: 1 }
                        }
                        key={i}
                      >
                        {((value === 'Target Platform' ||
                          value === 'Target Campaign Name') && (
                          <Tooltip title={key?.[value] || ''}>
                            <Autocomplete
                              size='small'
                              fullWidth
                              value={key?.[value] || null}
                              options={dropDown?.[value] || []}
                              onChange={(event, newValue) =>
                                handleTableChanges(
                                  value,
                                  newValue,
                                  key?.['Sno']
                                )
                              }
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  label={value}
                                  variant='outlined'
                                  name={value}
                                />
                              )}
                            />
                          </Tooltip>
                        )) ||
                          key?.[value]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))) || (
                <TableRow>
                  <TableCell
                    colSpan={Object.keys(TableData[0])?.length}
                    sx={{ p: 5 }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%'
                      }}
                    >
                      <Alert severity='error' variant='outlined'>
                        No matching records found. Please adjust your search criteria.
                      </Alert>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={Object.keys(TableData[0]).length} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{
                    position: 'sticky',
                    bottom: 0,
                    left: 0,
                    backgroundColor: 'white',
                    zIndex: 2
                  }}
                  rowsPerPageOptions={[5, 10, 20, { label: 'All', value: -1 }]}
                  colSpan={
                    (filtered.length > 0 && Object.keys(filtered[0])?.length) ||
                    1
                  }
                  count={filtered.length}
                  rowsPerPage={rowsPerPage}
                  page={Math.min(
                    page,
                    Math.max(0, Math.ceil(filtered.length / rowsPerPage) - 1)
                  )}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
    </>
  )
}

export default AI_Mapping
